class Viewport {
  constructor(options = {}) {
    this.callback = this.callback.bind(this);
    this.observer = new IntersectionObserver(this.callback, options);
    this.index = 0;
    this.intersectionCallbacks = {};
  }

  observe(target, isIntersectingCb = null, notIntersectingCb = null) {
    this.intersectionCallbacks[this.index] = {
      yes: isIntersectingCb,
      no: notIntersectingCb,
    };

    target.dataset.viewportIndex = this.index;
    this.index++;
    this.observer.observe(target);
  }

  callback(entries, observer) {
    entries.forEach((entry) => {
      const cb = this.intersectionCallbacks[entry.target.dataset.viewportIndex];

      if (entry.isIntersecting && cb.yes) {
        cb.yes(entry.target);
      } else if (cb.no) {
        cb.no(entry.target);
      }
    });
  }
}

const viewport = new Viewport();

export { viewport, Viewport };